export default __webpack_public_path__ + "tick.cb5d84f6b0f9a8bbde1bd3b01c1f2757.png";